/* ============================================================================
 * eyeoo-anchor-offset.js  —  v2
 * Progetto: Comelstile (Avante 14.0) — network Eye-oo
 * ----------------------------------------------------------------------------
 * PROBLEMA
 * Saltando a un ancoraggio interno (#EyeooBrands-D) il bersaglio finisce
 * sotto le barre ancorate in cima — header del tema e, sulla pagina brand,
 * barra lettere sticky — e sembra che il salto non abbia funzionato.
 *
 * PERCHE' scroll-margin-top NON RISOLVE, QUI
 * Misurato in pagina: scroll-margin-top risolveva a 210px con una fascia
 * coperta di 133,5px. Con lo scorrimento nativo la lettera sarebbe finita
 * 76px SOTTO il bordo dell'header, quindi visibile. Non lo era: segno che
 * lo scroll non e' nativo. Avante espone data-anchor-scroll="both" su
 * <html> e gestisce il salto in JavaScript, e uno scrollTo calcolato in JS
 * ignora scroll-margin-top — che vale solo per lo scorrimento nativo.
 * Il calc() in eyeoo-brands.css resta comunque utile: copre il caso di
 * arrivo diretto con hash in URL, dove il salto lo fa il browser.
 *
 * PERCHE' NON BASTA CORREGGERE DOPO (approccio della v1)
 * La v1 attendeva la fine dello scroll e poi correggeva. Due difetti:
 * allo scadere del timeout correggeva comunque, anche con l'animazione del
 * tema ancora in corso, e il tema proseguiva fino al proprio bersaglio
 * annullando la correzione. Rincorrere l'animazione di un altro non
 * funziona: bisogna non farla partire.
 *
 * COSA FA LA v2
 * Intercetta il click in fase di CAPTURE SU window — il primo anello del
 * percorso dell'evento, prima di qualunque listener su document — blocca
 * la propagazione e scrolla lei, con l'offset misurato. Nessuna animazione
 * concorrente, nessuna corsa da vincere. Al termine verifica una volta,
 * perche' un header che si nasconde o si mostra durante lo scroll cambia
 * la fascia coperta.
 *
 * COME MISURA LA FASCIA COPERTA
 * Non indovina selettori: fa hit-testing. Interroga il punto in alto al
 * centro del viewport con elementsFromPoint, tiene solo gli elementi in
 * position fixed o sticky, prende il bordo inferiore piu' basso, poi
 * risonda appena sotto per scoprire barre impilate. Sopravvive al porting
 * su un tema diverso: i nomi delle classi cambiano, il metodo no.
 *
 * AMBITO
 * CONFIG.scope limita l'intercettazione ai link dentro un contenitore
 * (default: la pagina brand). Fuori da quell'ambito il tema resta padrone
 * dei propri ancoraggi: stopPropagation su window e' potente e non va
 * esteso oltre il necessario. CONFIG.scope = '' lo applica a tutta la
 * pagina, da valutare caso per caso.
 *
 * PERCHE' IL RITOCCO E' UNIDIREZIONALE
 * L'header di Avante ha stick_on_scroll: si nasconde scorrendo in giu' e
 * riappare alla fermata. Un ritocco bidirezionale misurava 0px di fascia
 * coperta mentre l'header era nascosto, spostava il bersaglio a 16px dal
 * bordo, e l'header riapparendo lo copriva. Ora il ritocco puo' solo
 * rivelare: nel caso peggiore non fa nulla.
 *
 * Additivo: nessuna modifica ai file del tema.
 * ========================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    /* Contenitore dei link da gestire. '' = tutti gli ancoraggi interni. */
    scope: '.eyeoo-brands',

    /* true  = intercetta il click e scrolla noi (deterministico)
       false = lascia scrollare il tema e corregge dopo l'assestamento */
    takeOver: true,

    /* Respiro tra la barra piu' bassa e il bersaglio. */
    gap: 16,

    /* Un elemento sticky piu' alto di questa quota di viewport non e' una
       barra ma un contenitore: ignorato, falserebbe la misura. */
    maxBarRatio: 0.4,

    /* Sondaggi massimi verso il basso per le barre impilate. */
    maxProbes: 6,

    behavior: 'smooth',

    /* Attesa massima perche' lo scroll si fermi. */
    settleTimeout: 1500,

    debug: false
  };

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[eyeoo-anchor-offset]'].concat([].slice.call(arguments)));
    }
  }

  function reduceMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* --------------------------------------------------------------------
   * Misura della fascia coperta
   * ------------------------------------------------------------------ */

  function pinnedBottomAt(x, y) {
    if (!document.elementsFromPoint) return 0;

    var stack = document.elementsFromPoint(x, y);
    var limit = window.innerHeight * CONFIG.maxBarRatio;
    var bottom = 0;

    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      var position = window.getComputedStyle(el).position;
      if (position !== 'fixed' && position !== 'sticky') continue;

      var rect = el.getBoundingClientRect();
      if (rect.height <= 0 || rect.height > limit) continue;
      /* Deve coprire il punto venendo dall'alto. */
      if (rect.top > y + 1) continue;
      if (rect.bottom > bottom) bottom = rect.bottom;
    }

    return bottom;
  }

  function pinnedBottom() {
    var x = Math.round(window.innerWidth / 2);
    var y = 1;
    var bottom = 0;

    for (var probe = 0; probe < CONFIG.maxProbes; probe++) {
      var found = pinnedBottomAt(x, y);
      /* Nessuna barra nuova sotto la precedente: lo stack e' finito. */
      if (found <= bottom + 1) break;
      bottom = found;
      y = Math.round(bottom) + 1;
      if (y > window.innerHeight * 0.5) break;
    }

    return bottom;
  }

  /* Altezza dichiarata dal tema. Serve da PAVIMENTO: un header con
     stick_on_scroll e' nascosto durante lo scorrimento verso il basso,
     quindi la misura istantanea vale 0 e sottostima la fascia coperta.
     --header-height ne conserva l'altezza piena. Le due fonti si coprono
     a vicenda: la variabile dove la misura sbaglia, la misura dove la
     variabile vale 0 (su questo store accade sulle collection). */
  function declaredHeaderHeight() {
    var value = parseFloat(
      window.getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
    );
    return value > 0 ? value : 0;
  }

  function barsBottom() {
    var probed = pinnedBottom();
    var declared = declaredHeaderHeight();
    log('fascia coperta — misurata:', probed, '| dichiarata:', declared);
    return Math.max(probed, declared);
  }

  function offsetNow() {
    return barsBottom() + CONFIG.gap;
  }

  /* --------------------------------------------------------------------
   * Scroll
   * ------------------------------------------------------------------ */

  function afterScrollSettles(done) {
    var last = -1;
    var stable = 0;
    var start = Date.now();

    (function tick() {
      var y = window.scrollY;

      if (y === last) {
        stable++;
      } else {
        stable = 0;
        last = y;
      }

      /* Assestato davvero. */
      if (stable >= 3) {
        done(true);
        return;
      }

      /* Timeout: si segnala che NON e' assestato, cosi' il chiamante puo'
         decidere di non intervenire. La v1 correggeva comunque, in mezzo
         all'animazione del tema, e veniva sovrascritta. */
      if (Date.now() - start > CONFIG.settleTimeout) {
        done(false);
        return;
      }

      window.requestAnimationFrame(tick);
    })();
  }

  /* Ritocco finale, UNIDIREZIONALE: interviene solo se il bersaglio e'
     COPERTO, mai per recuperare spazio in eccesso.
     Il perche' e' una lezione pagata: con il ritocco bidirezionale, un
     header nascosto durante lo scroll (stick_on_scroll) faceva misurare
     una fascia di 0px, il ritocco concludeva che c'era troppo spazio e
     riportava il bersaglio a 16px dal bordo — dove l'header, riapparendo
     alla fine dello scroll, lo copriva. Il ritocco distruggeva un
     risultato che era gia' corretto.
     Potendo solo rivelare, nel caso peggiore non fa nulla. */
  function verify(target) {
    afterScrollSettles(function (settled) {
      if (!settled || !target.isConnected) return;

      var offset = offsetNow();
      var top = target.getBoundingClientRect().top;

      if (top >= offset - 1) {
        log('bersaglio visibile a', Math.round(top), '- nessun ritocco');
        return;
      }

      window.scrollBy({ top: top - offset, left: 0, behavior: 'auto' });
      log('ritocco di', Math.round(top - offset));
    });
  }

  function scrollToTarget(target, hash) {
    var rect = target.getBoundingClientRect();
    var top = Math.max(0, Math.round(window.scrollY + rect.top - offsetNow()));

    window.scrollTo({
      top: top,
      left: 0,
      behavior: reduceMotion() ? 'auto' : CONFIG.behavior
    });
    log('scroll a', top);

    /* L'hash va aggiornato a mano: avendo bloccato la navigazione, il
       browser non lo fa. pushState non emette hashchange, quindi non
       innesca una seconda gestione. */
    if (hash) {
      try {
        window.history.pushState(null, '', hash);
      } catch (error) {
        /* contesti che non consentono pushState: si rinuncia all'hash */
      }
    }

    verify(target);
  }

  function targetFromHash(hash) {
    if (!hash || hash === '#') return null;

    var id = hash.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (error) {
      /* hash non decodificabile: si usa cosi' com'e' */
    }

    return document.getElementById(id);
  }

  /* --------------------------------------------------------------------
   * Aggancio
   * ------------------------------------------------------------------ */

  function onClick(event) {
    if (event.defaultPrevented) return;
    /* Solo click primario senza modificatori: cmd/ctrl-click apre in una
       nuova scheda e non va intercettato. */
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href*="#"]');
    if (!link) return;
    if (CONFIG.scope && !link.closest(CONFIG.scope)) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    /* Solo ancoraggi nella pagina corrente. */
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname) return;

    var target = targetFromHash(url.hash);
    if (!target) return;

    if (!CONFIG.takeOver) {
      verify(target);
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    scrollToTarget(target, url.hash);
  }

  function onHashChange() {
    var target = targetFromHash(window.location.hash);
    if (target) verify(target);
  }

  function init() {
    /* CAPTURE SU window: primo anello del percorso dell'evento, quindi si
       arriva prima di qualunque listener su document — compreso quello del
       tema, che con data-anchor-scroll="both" gestisce lui gli ancoraggi. */
    window.addEventListener('click', onClick, true);
    window.addEventListener('hashchange', onHashChange);

    /* Arrivo diretto con hash in URL: il salto l'ha fatto il browser prima
       che questo script partisse, quindi si verifica comunque. */
    if (window.location.hash) onHashChange();

    if (window.EYEOO) {
      window.EYEOO.anchorOffset = {
        measure: pinnedBottom,
        bars: barsBottom,
        offset: offsetNow,
        scrollTo: scrollToTarget,
        config: CONFIG
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();